import styled from 'styled-components';

export const Label = styled.div<{ $customStyles?: string }>`
  background: linear-gradient(90deg, #3be2ff 0%, #ecbfbf 38.02%, #5c24ff 75.83%, #3be2ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: max-content;
  height: 32px;
  border-radius: 100px;
  padding: 6px 16px;
  color: #fff;
  position: absolute;
  top: calc(100% - 2px);
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  isolation: isolate;

  &::before {
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 100px;
    background-image: url(${'/assets/images/welcome/ai-label.png'});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &::after {
    content: '';
    position: absolute;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    top: 1px;
    left: 1px;
    border-radius: inherit;
    background: linear-gradient(90deg, #304593 0%, #363c4f 100%);
    z-index: -1;
  }

  ${({ $customStyles }) => $customStyles || ''}
`;
